import { useEffect, useRef, useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { AlertCircle, LoaderCircle } from 'lucide-react';
import { useAuth } from '@/hooks/use-auth';
import { readResearchCloudLaunch } from '@/lib/research-cloud-sso';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/sso')({ validateSearch: readResearchCloudLaunch, component: ResearchCloudSsoPage });

function ResearchCloudSsoPage() {
  const launch = Route.useSearch(), auth = useAuth(), started = useRef(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    // Scrub the launch credential and legacy identity hints before any request.
    history.replaceState({}, '', '/sso');
    void auth.completeSso(launch.sessionID, launch.audience).then(() => location.replace(launch.next)).catch(cause => {
      setError(cause instanceof Error ? cause.message : 'Research Cloud could not verify your session. Please launch AskBell again.');
    });
  }, [auth, launch]);
  return <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background px-4">
    <div aria-hidden className="absolute inset-0 bg-ui-canvas" />
    <Card className="relative w-full max-w-sm border-border/80 bg-card/95 ">
      <CardHeader className="text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-ui-md bg-primary text-ui-xl font-bold text-primary-foreground  shadow-primary/10">AB</div>
        <CardTitle>{error ? 'Unable to open AskBell' : 'Opening AskBell'}</CardTitle>
        <CardDescription>{error ? 'Your Research Cloud session could not be verified.' : 'Connecting your Research Cloud session�'}</CardDescription>
      </CardHeader>
      <CardContent>{error ? <div className="space-y-4">
        <div role="alert" className="flex items-start gap-3 rounded-ui-md border border-destructive/40 bg-destructive/5 p-3 text-ui-base text-destructive"><AlertCircle className="mt-0.5 h-4 w-4 shrink-0" /><span>{error}</span></div>
        <Button className="w-full" asChild><a href="https://bellomyrc.bellomyonline.com/" referrerPolicy="no-referrer">Return to Research Cloud</a></Button>
      </div> : <div className="flex justify-center py-3" role="status" aria-label="Verifying Research Cloud session"><LoaderCircle className="h-7 w-7 animate-spin text-primary" /></div>}</CardContent>
    </Card>
  </div>;
}
